import script from "./InternalTicketsDepartment.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalTicketsDepartment.vue?vue&type=script&setup=true&lang=js"

import "./InternalTicketsDepartment.vue?vue&type=style&index=0&id=1dc4d834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc4d834"]])

export default __exports__